/**
 * DOM element references used across main.ts and the auth module.
 *
 * Grabs happen at module load — behaviour-identical to the pre-extraction
 * code. The bundle is loaded with `<script defer>` in index.html, so the
 * DOM is guaranteed to be ready before any of these `getElementById`
 * calls run. `!` non-null assertions match the original code; if an ID
 * ever goes missing in public/index.html the app will crash at startup,
 * which is louder than a lazy null return.
 *
 * Extracted from main.ts as part of OMON-031 Phase 3.
 */

export const loginScreen = document.getElementById("loginScreen")!;
export const appScreen = document.getElementById("appScreen")!;
export const loginForm = document.getElementById("loginForm") as HTMLFormElement;
export const emailInput = document.getElementById("emailInput") as HTMLInputElement;
export const passwordInput = document.getElementById("passwordInput") as HTMLInputElement;
export const loginBtn = document.getElementById("loginBtn") as HTMLButtonElement;
export const loginError = document.getElementById("loginError")!;
export const forgotPasswordBtn = document.getElementById("forgotPasswordBtn") as HTMLButtonElement;
export const resetStatus = document.getElementById("resetStatus")!;
// AFHR-030: email-link door (tenant builds only — see auth.ts).
export const emailLinkBtn = document.getElementById("emailLinkBtn") as HTMLButtonElement;
export const usePasswordBtn = document.getElementById("usePasswordBtn") as HTMLButtonElement;
export const emailLinkStatus = document.getElementById("emailLinkStatus")!;
export const logoutBtn = document.getElementById("logoutBtn")!;
export const changePasswordBtn = document.getElementById("changePasswordBtn")!;
export const statusEl = document.getElementById("status")!;
export const clientsView = document.getElementById("clientsView")!;
export const catalogueSearch = document.getElementById("catalogueSearch") as HTMLInputElement;
export const catalogueList = document.getElementById("catalogueList")!;
export const addCustomFormArea = document.getElementById("addCustomFormArea")!;
export const modalContainer = document.getElementById("modalContainer")!;

// ── OMON-137 / OMON-186: admin surface DOM refs ──────────────────────
// These elements are always in the DOM (declared in index.html). Since
// OMON-186 the admin items are an icon group inside the left rail (no
// hamburger); shell.ts renders the group's contents on claims load. The
// two admin panels follow the same `.panel.active` pattern as the tabs.
export const adminMenu = document.getElementById("adminMenu")!;
export const adminUsersRolesList = document.getElementById("adminUsersRolesList")!;
export const adminAuditLogList = document.getElementById("adminAuditLogList")!;
